/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It counts against your device's clock and updates every second, so it is as accurate as your device's time setting.`)
};

const es_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta según el reloj de tu dispositivo y se actualiza cada segundo, así que es tan precisa como el ajuste de hora de tu dispositivo.`)
};

const de_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er zählt anhand der Uhrzeit deines Geräts und aktualisiert sich jede Sekunde, sodass er so genau ist wie die Zeiteinstellung deines Geräts.`)
};

const nl_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hij telt op basis van de klok van je apparaat en wordt elke seconde bijgewerkt, dus is hij zo nauwkeurig als de tijdsinstelling van je apparaat.`)
};

const fr_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il compte selon l'horloge de votre appareil et se met à jour chaque seconde, il est donc aussi précis que le réglage de l'heure de votre appareil.`)
};

const it_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta in base all'orologio del tuo dispositivo e si aggiorna ogni secondo, quindi è preciso quanto l'impostazione dell'ora del tuo dispositivo.`)
};

const pt_br2_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela conta com base no relógio do seu dispositivo e atualiza a cada segundo, então é tão precisa quanto o horário configurado no seu aparelho.`)
};

const pt_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta a partir do relógio do seu dispositivo e atualiza-se a cada segundo, pelo que é tão precisa quanto a definição de hora do seu dispositivo.`)
};

const ja_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お使いの端末の時計を基準にカウントし、1秒ごとに更新されるため、端末の時刻設定と同じ精度になります。`)
};

const zh_cd_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它根据你设备的时钟计算，并每秒更新，因此准确度取决于设备的时间设置。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_a1", locale)
	if (locale === "en") return en_cd_faq_a1(inputs)
	if (locale === "es") return es_cd_faq_a1(inputs)
	if (locale === "de") return de_cd_faq_a1(inputs)
	if (locale === "nl") return nl_cd_faq_a1(inputs)
	if (locale === "fr") return fr_cd_faq_a1(inputs)
	if (locale === "it") return it_cd_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_a1(inputs)
	if (locale === "pt") return pt_cd_faq_a1(inputs)
	if (locale === "ja") return ja_cd_faq_a1(inputs)
	return zh_cd_faq_a1(inputs)
};